import {FUNDRAISING_MODE} from '~/constants/LabModes';

export const isFundraisingMode = state =>
  state.labMode.get('mode') === FUNDRAISING_MODE;
